import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TipoEstudioPage",
    data() {
        let ss = new MainService();
        return {
            msg: "TipoEstudioPage",
            ss: ss,
            ajax: {
                "url": ss.indexTipoEstudio(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'TipoEstudio', name: 'TipoEstudio', title: 'Tipo Estudio' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripcion' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            // unidadAcademicas: [],
            tipoestudio: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newTipoEstudio() {
            this.tipoestudio = {};
            this.$refs['frm-tipoestudio'].show();
        },
        showTipoEstudio(id) {
            console.log("show");
            
            this.isLoading=true;
            this.ss.showTipoEstudio(id).then(
                (result) => {
                    let response = result.data;
                    this.tipoestudio = response.data;
                    this.$refs['view-tipoestudio'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editTipoEstudio() {
            this.$refs['frm-tipoestudio'].show();
            this.$refs['view-tipoestudio'].hide();
        },
        cancelTipoEstudio() {
            if (this.tipoestudio.id) {
                this.$refs['view-tipoestudio'].show();
            }
            this.$refs['frm-tipoestudio'].hide();
        },
        saveTipoEstudio() {
            this.ss.storeTipoEstudio(this.tipoestudio).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-tipoestudio'].hide();
                    this.$refs['datatable-tipoestudio'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        destroyTipoEstudio() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyTipoEstudio(this.tipoestudio)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-tipoestudio'].hide();
                                this.$refs['datatable-tipoestudio'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-TipoEstudio').on('click', (evt) => {
                console.log("evento click");
                const data = window.$(evt.target)[0].id;
                this.showTipoEstudio(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
